import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import Typography from "@mui/material/Typography";
import { AccountInfo } from "@azure/msal-browser";
import { isNonEmptyString } from "../utils";

const arrangeName = (displayName?: string | null): string => {
  if (isNonEmptyString(displayName)) {
    if (displayName.includes(", ")) {
      const parts = displayName.split(", ");
      if (parts.length === 2) {
        return `${parts[1]} ${parts[0]}`;
      }
    }
    return displayName;
  }
  return "";
};

const WelcomeName = (): JSX.Element | null => {
  const { accounts } = useMsal();
  const [name, setName] = useState<string>("");

  useEffect(() => {
    if (Array.isArray(accounts) && accounts.length > 0) {
      const account = accounts[0] as AccountInfo;
      setName(arrangeName(account.name));
    } else {
      setName("");
    }
  }, [accounts]);

  return isNonEmptyString(name) ? (
    <Typography variant="h6" color="secondary">
      {name}
    </Typography>
  ) : null;
};

export default WelcomeName;
